import React, { Component } from 'react';
import './App.css';

export default class Video extends Component {
  render() {
    let result = null;
    if(this.props.video !== undefined)
    {
        result = <iframe src={this.props.video.url} allowfullscreen="" allow="autoplay" width="480" height="270" frameborder="0"></iframe>
    }
    return (
        <div>
        {result}
        </div>
    );
}
}




// WEBPACK FOOTER //
// ./src/Video.js